import { CheckMyPermissionDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { ReactNode } from 'react';
import { usePermissionsBoundary } from './permissions-boundary.hook';

export function PermissionBoundary({
  permissions,
  onlyRequireSomePermissions,
  skipPermissionsChecks,
  availableUiFeatures,
  notify,
  placeholder,
  children
}: {
  permissions?: CheckMyPermissionDto[];
  onlyRequireSomePermissions?: boolean;
  skipPermissionsChecks?: boolean;
  availableUiFeatures?: string[];
  notify?: {
    render: string | (() => JSX.Element);
  };
  placeholder?: string | (() => JSX.Element);
  children: ReactNode;
}) {
  const { isLoading, isRejected } = usePermissionsBoundary({
    permissions,
    onlyRequireSomePermissions,
    availableUiFeatures
  });

  if (isLoading && !placeholder) {
    return null;
  }

  if (isLoading && placeholder) {
    return typeof placeholder === 'string' ? <span>{placeholder}</span> : placeholder();
  }

  if (skipPermissionsChecks !== true && isRejected) {
    return !notify ? null : typeof notify.render === 'string' ? <span>{notify.render}</span> : notify.render();
  }

  return <>{children}</>;
}
